/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Question } from '@/types'

const openDentalOptions = {
  'Patient Demographics': [
    { value: 'patients.FName', label: 'Legal First Name' },
    { value: 'patients.MiddleI', label: 'Middle Name' },
    { value: 'patients.LName', label: 'Legal Last Name' },
    { value: 'patients.Preferred', label: 'Preferred Name' },
    { value: 'patients.Gender', label: 'Gender*' },
    { value: 'patients.Position', label: 'Marital Status*' },
    { value: 'patients.Birthdate', label: 'Date of Birth*' },
    { value: 'patients.SSN', label: 'SSN' },
    { value: 'patients.Address', label: 'Address' },
    { value: 'patients.Address2', label: 'Address Line 2' },
    { value: 'patients.City', label: 'City' },
    { value: 'patients.State', label: 'State*' },
    { value: 'patients.Zip', label: 'Zip' },
    { value: 'patients.HmPhone', label: 'Home Phone' },
    { value: 'patients.WkPhone', label: 'Work Phone' },
    { value: 'patients.WirelessPhone', label: 'Wireless Phone' },
    { value: 'patients.Email', label: 'Email' },
  ],
  Reports: [
    {
      value: 'documents.Credit_Approval#136|ImgType=Document',
      label: 'Credit Approval',
    },
    { value: 'documents.Financial#134|ImgType=Document', label: 'Financial' },
    { value: 'documents.Insurance#131|ImgType=Document', label: 'Insurance' },
    {
      value: 'documents.Medical_History#130|ImgType=Document',
      label: 'Medical History',
    },
    {
      value: 'documents.Miscellaneous#137|ImgType=Document',
      label: 'Miscellaneous',
    },
    {
      value: 'documents.Treatment_Plans#132|ImgType=Document',
      label: 'Treatment Plans',
    },
    { value: 'documents.Letters#135|ImgType=Document', label: 'Letters' },
    { value: 'documents.BWs#179|ImgType=Document', label: 'BWs' },
    { value: 'documents.FMXs#180|ImgType=Radiograph', label: 'FMXs' },
    { value: 'documents.Panos#181|ImgType=Document', label: 'Panos' },
    { value: 'documents.Statements#240|ImgType=Document', label: 'Statements' },
    {
      value: 'documents.Tooth_Charts#252|ImgType=Document',
      label: 'Tooth Charts',
    },
    { value: 'documents.Lab_Slips#304|ImgType=Document', label: 'Lab Slips' },
    {
      value: 'documents.Payment_Plans#305|ImgType=Document',
      label: 'Payment Plans',
    },
    { value: 'documents.eClipboard#320|ImgType=File', label: 'eClipboard' },
    { value: 'documents.Photos#182|ImgType=Photo', label: 'Photos' },
    {
      value: 'documents.Patient_Pictures#190|ImgType=Photo',
      label: 'Patient Pictures',
    },
  ],
}

export const conditionalOpenDentalOptionsValue = (
  question: Question | undefined,
  key: string,
  includeFullName = false
) => {
  if (question?.question_type?.question_subtype === 'full_name') {
    // @ts-ignore
    let options = openDentalOptions[key].map((e: any) => {
      if (e.value === 'patients.FName') {
        return {
          label: 'Full Name',
          value: 'patients.full_name#FName:MiddleI:LName',
        }
      }

      return e
    })
    options = options.filter(
      (e: any) => e.value !== 'patients.MiddleI' && e.value !== 'patients.LName'
    )

    return options
  } else if (includeFullName) {
    return [
      {
        label: 'Full Name',
        value: 'patients.full_name#FName:MiddleI:LName',
      },
      // @ts-ignore
      ...openDentalOptions[key],
    ]
  }

  // @ts-ignore
  return openDentalOptions[key]
}
export default openDentalOptions
